module.exports = {"TXTCLI_In_N0_min":{"id":"TXTCLI_In_N0_min","defaultMessage":"Через {0} мин"},"TXTCLI_Now":{"id":"TXTCLI_Now","defaultMessage":"Сейчас"}}